import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState: Array<string> = [];

interface CitiesResponse {
	cities: Array<string>;
}

interface CityQuery {
	countryCode: string;
	stateCode: string;
}

// countryCode/stateCode are passed as the thunk params and appended as the query string by ApiProvider.
export const { thunk: fetchEventCities, slice: eventCitiesSlice } = getThunkAndSlice<CityQuery, CitiesResponse, Array<string>>({
	initialState,
	path: "/api/events/filter/cities",
	onAfterRequest: async (data: CitiesResponse | Array<string>) => {
		if (Array.isArray(data)) return data;
		return data.cities ?? [];
	},
});

export default eventCitiesSlice.reducer;
